const initialState = {
    current : 1,
    limit_to : 10
};

/**
 * importDataReducer: Reducer to handle actions related to import data.
 *
 * @param {any} state - The current state of the import data.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {any} The new state after applying the action.
 */
const importDataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_IMPORT_DATA":
      return action?.payload;
    default:
      return state;
  }
};

export default importDataReducer;

